import styled, { css } from 'styled-components'

import Segment from '../Segment'
import FlexRow from '../FlexRow'
import Icon from '../Icon'

export const StyledSegment = styled(Segment)`
  ${({ theme }) => css`
    &&& {
      background: ${theme.colors.lightGrey};
      display: flex;
      flex-direction: column;
      border-radius: 4px;
      padding: 20px;
      margin: 20px 0;
      border: 0;
    }
  `}
`
export const Content = styled.div`
  position: relative;
  min-height: 100px;
  margin-top: 1em;
`

export const StyledFlexRow = styled(FlexRow).attrs({
  noMargin: true,
  alignItems: 'center',
})`
  &&& {
    width: 100%;
    cursor: pointer;
  }
`

export const Handle = styled(Icon).attrs({
  name: 'icon-dragdrop',
  className: 'handle',
  size: 'big',
})`
  &&& {
    color: #bdcbd0;
    cursor: move;
    margin-right: 5px;
  }
`

export const ToggleIcon = styled(Icon).attrs({
  button: true,
})`
  &&& {
    top: -4px;
    font-size: 10px !important;
    margin-right: 15px;
  }
`
